export interface ValidationErrorItem {
    key: string,
    errorText: string
}
